import { Kicker, MaskLines, Rise, SlideShell } from "@/deck/ui";
import { PhoneAI } from "@/mockups/PhoneAI";
import { BMDashboard } from "@/mockups/BMDashboard";
import { QrisPay } from "@/mockups/QrisPay";

const Label = ({ n, title, hint }) => (
  <div className="mb-3 flex items-baseline justify-between gap-3">
    <p className="whitespace-nowrap font-display text-lg font-semibold tracking-tight text-zinc-50">
      <span className="mr-2 font-mono-d text-xs text-[var(--dash)]">{n}</span>
      {title}
    </p>
    <span className="truncate font-mono-d text-[11px] uppercase tracking-[0.16em] text-zinc-500">{hint}</span>
  </div>
);

export default function Product() {
  return (
    <SlideShell testId="product-slide" className="lg:pt-[4.75rem]">
      <div className="mb-4 flex flex-col gap-2 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <Rise><Kicker index="04">The product · live demo</Kicker></Rise>
          <MaskLines lines={["Three surfaces. One brain."]} className="mt-3 text-3xl font-extrabold leading-[0.95] tracking-[-0.035em] sm:text-4xl lg:text-5xl" />
        </div>
        <Rise delay={0.3}>
          <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-zinc-400">Tap anything — it's interactive</p>
        </Rise>
      </div>
      <div className="grid flex-1 gap-6 lg:min-h-0 lg:grid-cols-[minmax(0,290px)_minmax(0,1fr)_minmax(0,290px)] lg:gap-8">
        <Rise delay={0.3} className="flex min-h-0 flex-col">
          <Label n="01" title="Dash AI Assistant" hint="Chat · Call" />
          <PhoneAI />
        </Rise>
        <Rise delay={0.42} className="flex min-h-0 flex-col">
          <Label n="02" title="BM Dashboard" hint="Real-time" />
          <BMDashboard />
        </Rise>
        <Rise delay={0.54} className="flex min-h-0 flex-col">
          <Label n="03" title="Payment Gateway" hint="QRIS" />
          <QrisPay />
        </Rise>
      </div>
    </SlideShell>
  );
}
